import React from 'react';
import { Row, Col, Input } from 'antd';

import FormInput from 'components/FormInput';
import TextArea from 'antd/lib/input/TextArea';
import Form, { FormInstance } from 'antd/lib/form';
import ParListSelectWithLabelInValue from 'components/ParListSelectWithLabelInValue';
import ContractListSelect from 'components/ContractListSelect';

export type TabTPComplaintProps = {
  entityReference: string;
  objectid?: number;
  form?: FormInstance;
};

const TabTPComplaint = ({
  objectid,
  form,
  entityReference,
}: TabTPComplaintProps) => (
  <Form form={form} labelCol={{ span: 5 }} labelAlign="left">
    <Row gutter={20}>
      <Col span={10}>
        <FormInput
          col
          xs={24}
          lg={24}
          name="motif"
          comcode="motif"
          rules={[{ required: true }]}
        >
          <ParListSelectWithLabelInValue
            parcode="COMPLAINT"
            onSelect={(e) => {
              form?.setFieldsValue({
                externalreference: e.label,
                status: e.value,
              });
            }}
          />
        </FormInput>
        <FormInput
          col
          xs={24}
          lg={24}
          name="status"
          hidden
          //rules={[{ required: true }]}
        >
          <Input hidden />
        </FormInput>
        <FormInput
          col
          xs={24}
          lg={24}
          name="externalreference"
          hidden
          //rules={[{ required: true }]}
        >
          <Input />
        </FormInput>
      </Col>
      <Col span={12}>
        <FormInput col xs={24} lg={24} name="subentityid" comcode="Contract">
          <ContractListSelect tpreference={entityReference} />
        </FormInput>
        <FormInput
          col
          xs={24}
          lg={24}
          name="comment"
          comcode="comment"
          rules={[{ required: true }]}
        >
          <TextArea rows={6} />
        </FormInput>
      </Col>
    </Row>
  </Form>
);

export default TabTPComplaint;
